import DynamicTitle from './DynamicTitle'
import TableComponent from './TableComponent'

const FinanceTable = ({ typePrefix }) => {
  return (
    <div>
      <DynamicTitle />
      <TableComponent typePrefix={typePrefix} />
    </div>
  )
}

export default FinanceTable
